import React from 'react'
import { AutoComplete } from 'app/maps'

const theme = {
  div: null,
  label: 'label block mb-2',
  input: 'input',
  error: 'text-sm text-red-400 mt-1',
}

export default function Location(props) {
  const {
    types,
    value,
    onChange,
    className,
    classNames,
    divProps,
    label,
    labelClassName,
    labelProps,
    error,
    errorProps,
    ...inputProps
  } = props

  const styles = { ...theme, ...classNames }

  return (
    <div className={styles.div} {...divProps}>
      {label && (
        <label className={[styles.label, labelClassName]} {...labelProps}>
          {label}
        </label>
      )}
        <AutoComplete
          types={types}
          onPlaceChanged={location => {
            onChange && onChange(location.formatted, location)
          }}
        >
          <input
            type="text"
            {...inputProps}
            className={[styles.input, className]}
            value={onChange ? value || '' : value}
            onChange={event => {
              onChange && onChange(event.target.value || null, null)
            }}
          />
        </AutoComplete>
      {error && (
        <div className={styles.error}>
          {error}
        </div>
      )}
    </div>
  )
}
